import React from 'react';
import Icon from '../../../components/AppIcon';

const SearchBar = ({ value, onChange, placeholder = "Search industries..." }) => {
  return (
    <div className="relative w-full">
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="Search" size={20} color="var(--color-muted-foreground)" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder={placeholder}
        className="w-full h-12 pl-12 pr-4 rounded-lg border border-border bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
        aria-label="Search industries"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-muted rounded-md transition-colors"
          aria-label="Clear search"
        >
          <Icon name="X" size={16} color="var(--color-muted-foreground)" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;